export type ImageName = keyof typeof images

export const images = {
  avatar: '/assets/images/il-avatar-white.svg',
  logoAmb: '/assets/images/logo.svg',
  logoNemi: '/assets/images/logo-nemi.svg',
  logoNemiRounded: '/assets/images/logo-nemi-rounded.svg',
  logoWhite: '/assets/images/logo-white.svg',
  logoNemiVerde: '/assets/images/logo-nemi-verde.svg',
  logoNemiOnlyN: '/assets/images/logo-nemi-only-n.svg',
  logoBeiraBaixa: '/assets/images/logo-beirabaixa.png',
  logoBeiraBaixaRounded: '/assets/images/logo-beirabaixa-rounded.png',
  ambLogo: '/assets/images/amb-logo.svg',
  noReservations: '/assets/images/il-no-reservations.svg',
  noOptions: '/assets/images/il-no-opciones.svg',
  ticket: '/assets/images/ticket.svg',
  price: '/assets/images/price.svg',
  plus: '/assets/images/ic-plus.svg',
  plusWhite: '/assets/images/ic-plus-white.svg',
  options: '/assets/images/ic-options.svg',
  expand: '/assets/images/ic-expand.svg',
  faceHappy: '/assets/images/ic-face-happy.svg',
  star: '/assets/images/ic-star.svg',
  starSelected: '/assets/images/ic-star-filled.svg',
  settings: '/assets/images/ic-settings.svg',
  noFavorites: '/assets/images/ic-no-favorites.svg',
  back: '/assets/images/ic-back.svg',
  stopDisabled: '/assets/images/ic-stop-disabled.svg',
  stopDestination: '/assets/images/ic-stop-end.svg',
  stopOrigin: '/assets/images/ic-stop-origin.svg',
  stop: '/assets/images/ic-stop.svg',
  arrowRight: '/assets/images/ic-arrow-right.svg',
  close: '/assets/images/ic-close.svg',
  map: '/assets/images/ic-map.svg',
  list: '/assets/images/ic-list.svg',
  less: '/assets/images/ic-less.svg',
  more: '/assets/images/ic-more.svg',
  bus: '/assets/images/bus.svg',
  busSide: '/assets/images/bus-side.svg',
  faceMeh: '/assets/images/ic-face-meh.svg',
  faceMehLightOrange: '/assets/images/ic-face-meh-light-orange.svg',
  faceHappyGreen: '/assets/images/ic-face-happy-green.svg',
  faceSad: '/assets/images/ic-face-sad.svg',
  faceSadOrange: '/assets/images/ic-face-sad-orange.svg',
  faceDizzy: '/assets/images/ic-face-dizzy.svg',
  faceDizzyPink: '/assets/images/ic-face-dizzy-pink.svg',
  web: '/assets/images/il-web.svg',
  phone: '/assets/images/il-phone.svg',
  phoneRed: '/assets/images/il-phone-red.svg',
  email: '/assets/images/il-email.svg',
  galileo: '/assets/images/logo_G4M.svg',
  gsa: '/assets/images/gsa_logo_negatif_CMYK_300dpi_3.svg',
  pedestrian: '/assets/images/pedestrian.svg',
  info: '/assets/images/ic-info.svg',
  infoOutline: '/assets/images/ic-info-outline.svg',
  nemiLogo: '/assets/images/nemi-logo.svg',
  penaltyCero: '/assets/images/il-incidencias-0.svg',
  penaltyFirst: '/assets/images/il-incidencias-1.svg',
  penaltySecond: '/assets/images/il-incidencias-2.svg',
  penaltyThird: '/assets/images/il-incidencias-4.svg',
  bigBus: '/assets/images/il-bus.svg',
  checkBoxEmpty: '/assets/images/ic-checkbox-empty.svg',
  checkBoxFilled: '/assets/images/ic-checkbox-filled.svg',
  checkBoxFilledRed: '/assets/images/ic-checkbox-filledred.svg',
  checkboxChecked: '/assets/images/checkbox-checked.svg',
  checkboxUnchecked: '/assets/images/checkbox-unchecked.svg',
  myLocation: '/assets/images/ic-my-location.svg',
  area: '/assets/images/il-area.svg',
  clear: '/assets/images/ic-clear.svg',
  lens: '/assets/images/ic-lens.svg',
  check: '/assets/images/ic-check.svg',
  checkLanguage: '/assets/images/ic-check-language.svg',
  checkArea: '/assets/images/ic-check-language.svg',
  down: '/assets/images/ic-arrow-down.svg',
  up: '/assets/images/ic-arrow-up.svg',
  goBack: '/assets/images/ic-arrow-back.svg',
  inStop: '/assets/images/ic-stop-origin.svg',
  outStop: '/assets/images/ic-stop-end.svg',
  pin: '/assets/images/il-pin.svg',
  background: '/assets/images/map-background.svg',
  splash: '/assets/images/splash.svg',
  link: '/assets/images/link.svg',
  positive: '/assets/images/il-positive.svg',
  negative: '/assets/images/il-negative.svg',
  userInfo: '/assets/images/userInfo.svg',
  changePassword: '/assets/images/changePassword.svg',
  changeLanguage: '/assets/images/changeLanguage.svg',
  areaSelection: '/assets/images/areaSelection.svg',
  notificationSettings: '/assets/images/notificationSettings.svg',
  unsubscribe: '/assets/images/unsubscribe.svg',
  information: '/assets/images/information.svg',
  termsOfUse: '/assets/images/terms-of-use.svg',
  complaintsAndSuggestions: '/assets/images/complaints-and-suggestions.svg',
  objectsLost: '/assets/images/objects-lost.svg',
  ca: '/assets/images/language_ca.svg',
  es: '/assets/images/language_es.svg',
  en: '/assets/images/language_en.svg',
  it: '/assets/images/language_it.svg',
  fr: '/assets/images/language_fr.svg',
  de: '/assets/images/language_de.svg',
  el: '/assets/images/language_el.svg',
  eu: '/assets/images/language_eu.svg',
  hr: '/assets/images/language_hr.svg',
  hu: '/assets/images/language_hu.svg',
  nl: '/assets/images/language_nl.svg',
  pt: '/assets/images/language_pt.svg',
  si: '/assets/images/language_si.svg',
  webPage: '/assets/images/world.svg',
  googleIcon: '/assets/images/google-icon.svg',
  lockRequired: '/assets/images/ic-lock-required.svg',
  phoneInfo: '/assets/images/phone.svg',
  emailInfo: '/assets/images/email.svg',
  filter: '/assets/images/filter.svg',
  cross: '/assets/images/ic-cross.svg',
  delete: '/assets/images/ic-trash.svg',
  qrCode: '/assets/images/qr.svg',
  paymentMethod: '/assets/images/ic-genericcard.svg',
  password_visibility: './assets/images/eye_icon.svg',
  password_no_visibility: './assets/images/eye_crossed_icon.svg',
  realTime: '/assets/images/realTime.svg',
  clock: '/assets/images/clock.svg',
  avgPace: '/assets/images/avg-pace.svg',
  menuBurger: '/assets/images/menu-burger.svg',
  directionArrow: '/assets/images/direction-arrow.svg',
  seat: '/assets/images/user.svg',
  prmSeat: '/assets/images/prm.svg',
  alteration: '/assets/images/alteration.svg',
  calendar: '/assets/images/calendar.svg',
  signpost: '/assets/images/signpost.svg',
  arrowLeft: '/assets/images/arrow-left.svg',
}
